export const NAME = 'name';
export const OWNER = 'owner';
export const ADDRESS = 'address';
export const STREET_ADDRESS = 'streetAddress';
export const STREET_ADDRESS_2 = 'streetAddress2';
export const CITY = 'city';
export const REGION = 'region';
export const POSTAL_CODE = 'postalCode';
export const COUNTRY = 'country';
export const TIME_ZONE = 'timeZone';
